import api from "../../../../services/api"

// Detalhes salvos da entrega (link de rastreio, uuid, status, entregador, códigos na observação).
// Reaproveita o DeliveryResource, o mesmo que alimenta os detalhes de entrega no painel.
export const buscarDetalhesEntregaFlux = async idDoPedido => {
    let detalhes
    await api
        .get(`delivery/${idDoPedido}`, {
            headers: { "Content-Type": "application/json" },
        })
        .then(response => {
            detalhes = response
        })
        .catch(error => {
            detalhes = { data: { erro: error?.message || "Falha ao carregar detalhes" } }
        })
    return detalhes
}

// Último status da entrega direto na Flux (JSON cru da API da Flux).
export const buscarStatusEntregaFlux = async idDoPedido => {
    let resposta
    await api
        .get(`flux/entrega/status/${idDoPedido}`, {
            headers: { "Content-Type": "application/json" },
        })
        .then(response => {
            resposta = response
        })
        .catch(error => {
            resposta = { data: { erro: error?.message || "Falha ao consultar a Flux" } }
        })
    return resposta
}

// Situação do último envio da entrega à Flux (sucesso + mensagem de erro), para indicar falhas no painel.
export const buscarSituacaoEnvioFlux = async idDoPedido => {
    let resposta
    await api
        .get(`flux/entrega/situacao/${idDoPedido}`, {
            headers: { "Content-Type": "application/json" },
        })
        .then(response => {
            resposta = response
        })
        .catch(error => {
            resposta = { data: { erro: error?.message || "Falha ao consultar a situação" } }
        })
    return resposta
}

// Reenvia a entrega à Flux na hora (síncrono) e devolve a situação resultante {sucesso, mensagem}.
export const reenviarEntregaFlux = async idDoPedido => {
    let resposta
    await api
        .post(
            `flux/entrega/reenviar/${idDoPedido}`,
            {},
            { headers: { "Content-Type": "application/json" } }
        )
        .then(response => {
            resposta = response
        })
        .catch(error => {
            resposta = {
                data: { sucesso: false, mensagem: error?.message || "Falha ao reenviar" },
            }
        })
    return resposta
}

// Códigos de verificação da entrega (cliente/coleta/retorno) direto na Flux.
export const buscarCodigosVerificacaoFlux = async idDoPedido => {
    let resposta
    await api
        .get(`flux/entrega/codigos/${idDoPedido}`, {
            headers: { "Content-Type": "application/json" },
        })
        .then(response => {
            resposta = response
        })
        .catch(error => {
            resposta = { data: { erro: error?.message || "Falha ao consultar a Flux" } }
        })
    return resposta
}
